import { Component, Input, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-error-message',
  templateUrl: './error-message.component.html',
  styleUrls: ['./error-message.component.css']
})
export class ErrorMessageComponent implements OnInit {

  @Input() errorMsg: string = '';
  constructor() { }

  ngOnInit(): void {
  }

}
